import { render } from "./Bookingservices.vue?vue&type=template&id=6a06cbf4&scoped=true"
import script from "./Bookingservices.vue?vue&type=script&lang=js"
export * from "./Bookingservices.vue?vue&type=script&lang=js"

import "./Bookingservices.vue?vue&type=style&index=0&id=6a06cbf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a06cbf4"]])

export default __exports__